/** @format */

import React, { useState } from "react";

//import icons
import { RiArrowDownSFill } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { AiFillEdit } from "react-icons/ai";
import { MdOutlineAdd } from "react-icons/md";
import { FormControlLabel, Switch } from "@mui/material";

export const MenuBtn = () => {
  const [listToggle, setListToggle] = useState(false);
  const [activePop, setActivePop] = useState("");
  return (
    <div className='menu-btn__box'>
      <div className='menu-btn'>
        <button
          className='filter__menu__btn btn btn__white  '
          onClick={() => setListToggle(!listToggle)}>
          الكل
          <IoIosArrowDown className='react-icon' />
        </button>

        {listToggle && (
          <ul className='menu-btn__list'>
            <li className='menu-btn__item' onClick={() => setActivePop("edit")}>
              {" "}
              الكـــــــــــــــل{" "}
            </li>
            <li
              className='menu-btn__item'
              onClick={() => setActivePop("deliver")}>
              {" "}
              طلبــــــات تمت{" "}
            </li>
            <li className='menu-btn__item' onClick={() => setActivePop("sell")}>
              {" "}
              طلبات قيد الانتظار{" "}
            </li>
            <li
              className='menu-btn__item'
              onClick={() => setActivePop("sponser")}>
              {" "}
              طلبـــــات لم تتم{" "}
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export const StepsBtns = () => {
  const [activePop, setActivePop] = useState("");

  return (
    <>
      <ul className='steps-vertical'>
        <li className='steps-vertical__item '>
          <span className='steps-vertical__num steps-vertical__num-active'>
            1
          </span>
          Create
          <span className='steps-vertical__ball-1'></span>
          <span className='steps-vertical__ball-2'></span>
          <span className='steps-vertical__ball-3'></span>
        </li>
        <li
          className='steps-vertical__item'
          onClick={() => setActivePop("reserve")}>
          <span className='steps-vertical__num'>2 </span>Resrvation
          <span className='steps-vertical__ball-1'></span>
          <span className='steps-vertical__ball-2'></span>
          <span className='steps-vertical__ball-3'></span>
        </li>
        <li
          className='steps-vertical__item'
          onClick={() => setActivePop("visa")}>
          <span className='steps-vertical__num'>3</span>Visa
        </li>
      </ul>
    </>
  );
};

export const ActionMenu = () => {
  return (
    <div>
      <button className='btn btn__action'>
        Action
        <RiArrowDownSFill className='react-icon primary' />
      </button>
    </div>
  );
};

export const EditBtn = ({ title }) => {
  return (
    <div className='edit-info primary'>
      <AiFillEdit />
      {title}{" "}
    </div>
  );
};

export const AddBtn = () => {
  return (
    <div
      className='edit-info primary'
      style={{
        backgroundColor: "#EDEAFB",
        color: "#6D54DE",
        fontSize: "3rem",
        marginBottom: "1rem",
        borderRadius: "1.5rem",
      }}>
      <MdOutlineAdd style={{ fontSize: "5rem", color: "#6D54DE" }} />
    </div>
  );
};
export const BlockBtn = ({ action, value }) => {
  return (
    <div className='btn btn--red' onClick={() => action(true)}>
      حظر
    </div>
  );
};
export const BtnRed = ({ action, value }) => {
  return (
    <div className='btn btn--red' onClick={action}>
      {value}
    </div>
  );
};
export const UnBLock = ({ action }) => {
  return (
    <button className='btn btn--green' onClick={action}>
      اعادة تفعيل
    </button>
  );
};

export const CancelBtn = ({click}) => {
  return <button onClick={click} className='btn btn__danger'>الغاء</button>;
};

export const BtnPrimary = ({ action , click }) => {
  return <button onClick={click} className='btn btn__primary'>{action}</button>;
};

export const ToggleBtn = () => {
  return (
    <FormControlLabel
      sx={{
        display: "block",
        "& .MuiSwitch-thumb": {
          backgroundColor: "#FF8900 !important",
        },
        "& .MuiSwitch-track": {
          backgroundColor: "#FF8900 !important",
        },
        " & .Mui-checked+.MuiSwitch-track": {
          backgroundColor: "#FF8900 !important",
        },
      }}
      control={
        <Switch
          // checked={loading}
          // onChange={() => setLoading(!loading)}
          name='loading'
        />
      }
    />
  );
};
